export default "__VITE_ASSET__leKkXlz0__"